import * as React from 'react';
import { creditCardLabels } from '../../../../utils/braintree-apis/card-option-config';
import { Alert } from 'telstra-ui/components/alert/Alert';
import { GenericAlert } from 'telstra-ui/components/generic-alert/GenericAlert';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';
import global from '@applications/global';

interface ICreditCardFields {
    cardType: string;
}

export class CreditCardFields extends React.Component<ICreditCardFields, {}> {
    public constructor(props) {
        super(props);
    }
    public render() {
        return (
            <>
                {this.formFields()}
            </>
        )
    }
    private getDetailsText = (cardType: string) => {
        if  (cardType === 'SETUP_DD' || cardType === 'UPDATE_DD') {
            return {
                detailsClassName: 'setup-detail',
                detailsText: 'The card details you enter will be saved as a payment method.'
            }
        } else if  (cardType === 'EDIT_PAYMENT_METHOD') {
            return {
                detailsClassName: 'credit-card-detail',
                detailsText: 'Update card details'
            }
        }
    }
    private formFields = () => {
        const noShowDetails = ['ADD_PAYMENT_METHOD', 'PAY_NOW']
        const hidecardDetailsText = noShowDetails.includes(this.props.cardType);
        const detailsText = this.getDetailsText(this.props.cardType)
        const fields = creditCardLabels.map((eachField) => {
            return (eachField?.fields?.length > 0 ?
                <>
                    <div className="tc-hosted-field-label">
                        {eachField.label}
                    </div>
                    <div className="tc-hosted-subfield">
                        {
                            eachField.fields.map((subSection, index) => {
                                return (
                                    <div key={index} className='tc-hosted-section'>
                                        <div className={subSection.id === "cc-expiration-month" ?
                                            "tc-hosted-month-field" : "tc-hosted-year-field"} id={subSection.id}/>
                                        <div style={{clear: 'both'}} className="visible-xs" tabIndex={0} />
                                        <div className="invalid-field" id={"alert-" + subSection.id}>
                                            <Alert
                                                name={'alert-inline-warning'}
                                                label={ "This field is required" }
                                                icon="icon-system-alert-small"
                                                labelClass="alert-error-text text-regular"
                                            />
                                            <div style={{clear: 'both'}} className="visible-xs" />
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </>
                :
                <>
                    <div className="tc-hosted-field-label">
                        <div className={eachField.label === 'Security code (CVV)' ? "mobile-label-cvv" : "field-label"}>
                            {eachField.label}
                        </div>
                    </div>
                    {
                        eachField.id === 'cc-cvv' &&
                            <div className="tc-hosted-field-cvv" id={eachField.id}>
                                <div className="tc-cvv-icon">
                                    <SvgIcon name="icon-bills-cvv" className="custom-cvv-class"/>
                                </div>
                            </div>
                    }
                    {eachField.id !== 'cc-cvv' && <div className="tc-hosted-field" id={eachField.id} />}
                    {
                        eachField.id === 'cc-cvv' &&
                            <div className='cvv-info-text text-regular'>
                                <Alert
                                    label="Enter the 3 or 4 digit code"
                                />
                            </div>
                    }
                    <div className="invalid-field">
                        <Alert
                            name={'alert-inline-warning'}
                            label="This field is required"
                            icon="icon-system-alert-small"
                            labelClass="alert-error-text text-regular"
                        />
                    </div>
                </>
            );
        });
        return (
            <>
                {hidecardDetailsText ? <></> :
                    <div className={detailsText?.detailsClassName}>
                        { detailsText?.detailsText }
                    </div>}
                <>
                    <div className='tc-card-accepted-label'>Cards accepted</div>
                    <div className='tc-card-accepted-icon'>
                        <SvgIcon name="icon-network-visa" />
                        <SvgIcon name="icon-network-mastercard" className="cc-icon-padding"/>
                        <SvgIcon name="icon-bills-amex" />
                    </div>
                </>
                <div className='invalid-cc-error hide-invalid-alert'>
                    <GenericAlert
                        name="warning-CTA"
                        description="Some of your credit card details are invalid / empty. Please review and try again." />
                </div>
                <div className="tc-billing-braintree-hosted-fields">
                    {fields}
                </div>
            </>
        );
    }
}
